import { queryOptions, useQuery } from '@tanstack/react-query';

import { organizationsApi } from '../api/organizations-api';

import { organizationKeys } from './organization-keys';

export function organizationQueryOptions(organizationId: string) {
  return queryOptions({
    queryKey: organizationKeys.detail(organizationId),
    queryFn: () => organizationsApi.get(organizationId),
  });
}

export function useOrganization(organizationId: string) {
  return useQuery(organizationQueryOptions(organizationId));
}
